// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-footer {
  background: #0f1a2e;
  color: #c9d4e8;
  padding: 3rem 0 0;
  margin-top: 0;
  font-size: 0.9rem;
}
.site-footer .footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem 2.5rem;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.4fr;
  gap: 2.5rem;
}
@media (max-width: 900px) {
  .site-footer .footer-container {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 560px) {
  .site-footer .footer-container {
    grid-template-columns: 1fr;
  }
}
.site-footer .footer-brand .footer-logo {
  font-size: 1.6rem;
  font-weight: 800;
  color: #ffffff;
  margin: 0 0 0.75rem;
  letter-spacing: -0.5px;
}
.site-footer .footer-brand .footer-tagline {
  color: #94a3b8;
  line-height: 1.65;
  margin-bottom: 1.25rem;
}
.site-footer .footer-brand .footer-social {
  display: flex;
  gap: 0.75rem;
}
.site-footer .footer-brand .footer-social a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  color: #94a3b8;
  transition: background 0.2s, color 0.2s;
}
.site-footer .footer-brand .footer-social a:hover {
  background: #3b82f6;
  color: #ffffff;
}
.site-footer .footer-heading {
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #ffffff;
  margin: 0 0 1rem;
}
.site-footer .footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}
.site-footer .footer-links a {
  color: #94a3b8;
  text-decoration: none;
  transition: color 0.2s;
}
.site-footer .footer-links a:hover {
  color: #60a5fa;
}
.site-footer .footer-contact {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.site-footer .footer-contact li {
  display: flex;
  align-items: flex-start;
  gap: 0.55rem;
  color: #94a3b8;
}
.site-footer .footer-contact li svg {
  flex-shrink: 0;
  margin-top: 2px;
  color: #60a5fa;
}
.site-footer .footer-contact li a {
  color: #94a3b8;
  text-decoration: none;
  transition: color 0.2s;
}
.site-footer .footer-contact li a:hover {
  color: #60a5fa;
}
.site-footer .footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 1.1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  color: #64748b;
  font-size: 0.82rem;
}
@media (max-width: 560px) {
  .site-footer .footer-bottom {
    flex-direction: column;
    gap: 0.5rem;
    text-align: center;
  }
}
.site-footer .footer-bottom .footer-legal {
  display: flex;
  gap: 1.25rem;
}
.site-footer .footer-bottom .footer-legal a {
  color: #64748b;
  text-decoration: none;
  transition: color 0.2s;
}
.site-footer .footer-bottom .footer-legal a:hover {
  color: #94a3b8;
}
@media (prefers-color-scheme: dark) {
  .site-footer {
    background: #060e1c;
  }
}

.site-footer {
  position: relative;
  overflow: hidden;
  padding-top: 3.5rem;
  background: #2f8ccc;
  color: rgba(255, 255, 255, 0.86);
}
.site-footer .footer-container {
  position: relative;
  z-index: 1;
  padding-bottom: 4.5rem;
}
.site-footer .footer-brand .footer-tagline, .site-footer .footer-links a, .site-footer .footer-contact li, .site-footer .footer-contact li a {
  color: rgba(255, 255, 255, 0.72);
}
.site-footer .footer-links a:hover, .site-footer .footer-contact li a:hover {
  color: #fff;
}
.site-footer .footer-contact li svg {
  color: #fff;
}
.site-footer .footer-brand .footer-social a {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
}
.site-footer .footer-bottom {
  position: relative;
  z-index: 1;
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.18);
}
.site-footer .footer-bottom .footer-legal a {
  color: rgba(255, 255, 255, 0.7);
}
.site-footer .footer-bottom .footer-legal a:hover {
  color: #fff;
}
.site-footer::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: -35px;
  left: 0;
  height: 180px;
  opacity: 0.13;
  background: repeating-linear-gradient(90deg, transparent 0 45px, #fff 46px 48px, transparent 49px 82px);
  clip-path: polygon(0 100%, 0 75%, 6% 75%, 6% 55%, 11% 55%, 11% 82%, 18% 82%, 18% 42%, 23% 42%, 23% 70%, 31% 70%, 31% 52%, 38% 52%, 38% 78%, 45% 78%, 49% 0, 53% 78%, 60% 78%, 60% 45%, 66% 45%, 66% 72%, 73% 72%, 73% 35%, 78% 35%, 78% 70%, 85% 70%, 85% 50%, 91% 50%, 91% 79%, 100% 79%, 100% 100%);
}

.site-footer {
  position: relative;
  min-height: 335px;
  overflow: hidden;
  padding: 38px 0 0;
  background: #2f8ccc;
  color: rgba(255, 255, 255, 0.82);
  font-size: 12px;
}
.site-footer::after {
  display: none;
}
.site-footer .footer-container {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1.1fr 1fr 1fr 1fr 1.3fr;
  gap: clamp(28px, 5vw, 72px);
  width: min(100% - 48px, 1216px);
  max-width: 1216px;
  margin: 0 auto;
  padding: 0;
}
.site-footer .footer-brand__link {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: #fff;
  text-decoration: none;
  transition: opacity 0.2s ease;
}
.site-footer .footer-brand__link:hover {
  opacity: 0.8;
}
.site-footer .footer-brand__link:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 5px;
}
.site-footer .footer-brand__link img {
  width: 34px;
  height: 34px;
  filter: brightness(0) invert(1);
}
.site-footer .footer-brand__link strong {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.02em;
  white-space: nowrap;
}
.site-footer .footer-heading {
  margin: 0 0 14px;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}
.site-footer .footer-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.site-footer .footer-links a {
  color: rgba(255, 255, 255, 0.72);
  text-decoration: none;
  transition: color 0.2s ease;
}
.site-footer .footer-links a:hover {
  color: #fff;
}
.site-footer .footer-links a:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 3px;
}
.site-footer .footer-contact {
  display: block;
  margin: 0;
  padding: 0;
}
.site-footer .footer-contact p {
  margin: 0 0 10px;
  color: rgba(255, 255, 255, 0.72);
  line-height: 1.45;
}
.site-footer .footer-contact a {
  color: inherit;
  text-decoration: none;
  overflow-wrap: anywhere;
}
.site-footer .footer-contact a:hover {
  color: #fff;
}
.site-footer .footer-skyline {
  position: absolute;
  z-index: 1;
  right: 0;
  bottom: -3px;
  left: 0;
  width: 100%;
  height: 225px;
  object-fit: cover;
  object-position: center bottom;
  opacity: 0.34;
  filter: brightness(1.35);
  pointer-events: none;
}
.site-footer .footer-bottom {
  position: absolute;
  z-index: 2;
  right: 0;
  bottom: 12px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  max-width: none;
  margin: 0;
  padding: 0;
  border: 0;
  color: rgba(255, 255, 255, 0.75);
  font-size: 10px;
}
.site-footer .footer-bottom p {
  margin: 0;
}
.site-footer .footer-social {
  position: relative;
  display: block;
  width: 102px;
  height: 18px;
}
.site-footer .footer-social img {
  display: block;
  width: 102px;
  height: 18px;
  object-fit: contain;
}
.site-footer .footer-social a {
  position: absolute;
  z-index: 1;
  top: -4px;
  bottom: -4px;
  display: block;
}
.site-footer .footer-social a:hover {
  background: rgba(255, 255, 255, 0.12);
  border-radius: 5px;
}
.site-footer .footer-social a:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}
.site-footer .footer-social__facebook {
  left: 0;
  width: 22%;
}
.site-footer .footer-social__instagram {
  left: 29%;
  width: 28%;
}
.site-footer .footer-social__youtube {
  right: 0;
  width: 28%;
}
@media (max-width: 900px) {
  .site-footer {
    min-height: 470px;
  }
  .site-footer .footer-container {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 30px 50px;
  }
  .site-footer .footer-brand {
    grid-column: 1/-1;
  }
  .site-footer .footer-skyline {
    height: 235px;
  }
}
@media (max-width: 560px) {
  .site-footer {
    min-height: 690px;
    padding-top: 32px;
  }
  .site-footer .footer-container {
    grid-template-columns: 1fr;
    width: min(100% - 40px, 420px);
    gap: 25px;
  }
  .site-footer .footer-brand {
    grid-column: auto;
  }
  .site-footer .footer-skyline {
    left: -30%;
    width: 160%;
    max-width: none;
    height: 210px;
  }
  .site-footer .footer-bottom {
    bottom: 14px;
    flex-direction: column;
    gap: 9px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;AADF;AAGE;EACE,iBAAA;EACA,cAAA;EACA,wBAAA;EACA,aAAA;EACA,wCAAA;EACA,WAAA;AADJ;AAGI;EARF;IASI,8BAAA;EAAJ;AACF;AAEI;EAZF;IAaI,0BAAA;EACJ;AACF;AAGI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AADN;AAII;EACE,cAAA;EACA,iBAAA;EACA,sBAAA;AAFN;AAKI;EACE,aAAA;EACA,YAAA;AAHN;AAKM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,cAAA;EACA,uCAAA;AAHR;AAKQ;EACE,mBAAA;EACA,cAAA;AAHV;AASE;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AAPJ;AAUE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AARJ;AAUI;EACE,cAAA;EACA,qBAAA;EACA,sBAAA;AARN;AAUM;EACE,cAAA;AARR;AAaE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAXJ;AAaI;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AAXN;AAaM;EACE,cAAA;EACA,eAAA;EACA,cAAA;AAXR;AAcM;EACE,cAAA;EACA,qBAAA;EACA,sBAAA;AAZR;AAcQ;EAAU,cAAA;AAXlB;AAgBE;EACE,+CAAA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAdJ;AAgBI;EAXF;IAYI,sBAAA;IACA,WAAA;IACA,kBAAA;EAbJ;AACF;AAeI;EACE,aAAA;EACA,YAAA;AAbN;AAeM;EACE,cAAA;EACA,qBAAA;EACA,sBAAA;AAbR;AAeQ;EAAU,cAAA;AAZlB;AAkBE;EAxJF;IAyJI,mBAAA;EAfF;AACF;;AAmBA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;AAhBF;AAkBE;EAAoB,kBAAA;EAAoB,UAAA;EAAY,sBAAA;AAbtD;AAcE;EAA2F,gCAAA;AAX7F;AAYE;EAAoD,WAAA;AATtD;AAUE;EAAyB,WAAA;AAP3B;AAQE;EAAiC,qCAAA;EAAmC,WAAA;AAJtE;AAKE;EAAiB,kBAAA;EAAoB,UAAA;EAAY,+BAAA;EAA6B,uCAAA;AAChF;AAAE;EAAiC,+BAAA;AAGnC;AAHgE;EAAU,WAAA;AAM1E;AAJE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,uGAAA;EACA,qSAAA;AAMJ;;AADA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;AAIF;AAHE;EAAW,aAAA;AAMb;AAJE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,8CAAA;EACA,2BAAA;EACA,+BAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAMJ;AAHE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,qBAAA;EACA,6BAAA;AAKJ;AAJI;EAAU,YAAA;AAOd;AANI;EAAkB,uBAAA;EAAyB,mBAAA;AAU/C;AATI;EAAM,WAAA;EAAa,YAAA;EAAc,+BAAA;AAcrC;AAbI;EAAS,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;EAAwB,mBAAA;AAmBxE;AAhBE;EAAkB,gBAAA;EAAkB,WAAA;EAAa,eAAA;EAAiB,gBAAA;EAAkB,iBAAA;EAAmB,oBAAA;AAwBzG;AAvBE;EAAgB,aAAA;EAAe,sBAAA;EAAwB,SAAA;EAAW,SAAA;EAAW,UAAA;EAAY,gBAAA;AA+B3F;AA9BE;EAAkB,gCAAA;EAA8B,qBAAA;EAAuB,2BAAA;AAmCzE;AAlCE;EAAwB,WAAA;AAqC1B;AApCE;EAAgC,uBAAA;EAAyB,mBAAA;AAwC3D;AAtCE;EAAkB,cAAA;EAAgB,SAAA;EAAW,UAAA;AA2C/C;AA1CE;EAAoB,gBAAA;EAAkB,gCAAA;EAA8B,iBAAA;AA+CtE;AA9CE;EAAoB,cAAA;EAAgB,qBAAA;EAAuB,uBAAA;AAmD7D;AAlDE;EAA0B,WAAA;AAqD5B;AAnDE;EAAkB,kBAAA;EAAoB,UAAA;EAAY,QAAA;EAAU,YAAA;EAAc,OAAA;EAAS,WAAA;EAAa,aAAA;EAAe,iBAAA;EAAmB,8BAAA;EAAgC,aAAA;EAAc,wBAAA;EAA0B,oBAAA;AAiE5M;AA/DE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;AAiEJ;AAhEI;EAAI,SAAA;AAmER;AAhEE;EAAiB,kBAAA;EAAoB,cAAA;EAAgB,YAAA;EAAc,YAAA;AAsErE;AArEE;EAAqB,cAAA;EAAgB,YAAA;EAAc,YAAA;EAAc,mBAAA;AA2EnE;AA1EE;EAAmB,kBAAA;EAAoB,UAAA;EAAY,SAAA;EAAW,YAAA;EAAc,cAAA;AAiF9E;AAhFE;EAAyB,qCAAA;EAAmC,kBAAA;AAoF9D;AAnFE;EAAiC,uBAAA;EAAyB,mBAAA;AAuF5D;AAtFE;EAA2B,OAAA;EAAS,UAAA;AA0FtC;AAzFE;EAA4B,SAAA;EAAW,UAAA;AA6FzC;AA5FE;EAA0B,QAAA;EAAU,UAAA;AAgGtC;AA9FE;EA5EF;IA6EI,iBAAA;EAiGF;EAhGE;IAAoB,gDAAA;IAAkD,cAAA;EAoGxE;EAnGE;IAAgB,iBAAA;EAsGlB;EArGE;IAAkB,aAAA;EAwGpB;AACF;AAtGE;EAnFF;IAoFI,iBAAA;IACA,iBAAA;EAyGF;EAxGE;IAAoB,0BAAA;IAA4B,8BAAA;IAAsC,SAAA;EA6GxF;EA5GE;IAAgB,iBAAA;EA+GlB;EA9GE;IAAkB,UAAA;IAAY,WAAA;IAAa,eAAA;IAAiB,aAAA;EAoH9D;EAnHE;IAAiB,YAAA;IAAc,sBAAA;IAAwB,QAAA;EAwHzD;AACF","sourcesContent":["@import '../styles/variables';\n\n.site-footer {\n  background: #0f1a2e;\n  color: #c9d4e8;\n  padding: 3rem 0 0;\n  margin-top: 0;\n  font-size: 0.9rem;\n\n  .footer-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 1.5rem 2.5rem;\n    display: grid;\n    grid-template-columns: 2fr 1fr 1fr 1.4fr;\n    gap: 2.5rem;\n\n    @media (max-width: 900px) {\n      grid-template-columns: 1fr 1fr;\n    }\n\n    @media (max-width: 560px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .footer-brand {\n    .footer-logo {\n      font-size: 1.6rem;\n      font-weight: 800;\n      color: #ffffff;\n      margin: 0 0 0.75rem;\n      letter-spacing: -0.5px;\n    }\n\n    .footer-tagline {\n      color: #94a3b8;\n      line-height: 1.65;\n      margin-bottom: 1.25rem;\n    }\n\n    .footer-social {\n      display: flex;\n      gap: 0.75rem;\n\n      a {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 36px;\n        height: 36px;\n        border-radius: 50%;\n        background: rgba(255, 255, 255, 0.08);\n        color: #94a3b8;\n        transition: background 0.2s, color 0.2s;\n\n        &:hover {\n          background: #3b82f6;\n          color: #ffffff;\n        }\n      }\n    }\n  }\n\n  .footer-heading {\n    font-size: 0.85rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: #ffffff;\n    margin: 0 0 1rem;\n  }\n\n  .footer-links {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.55rem;\n\n    a {\n      color: #94a3b8;\n      text-decoration: none;\n      transition: color 0.2s;\n\n      &:hover {\n        color: #60a5fa;\n      }\n    }\n  }\n\n  .footer-contact {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n\n    li {\n      display: flex;\n      align-items: flex-start;\n      gap: 0.55rem;\n      color: #94a3b8;\n\n      svg {\n        flex-shrink: 0;\n        margin-top: 2px;\n        color: #60a5fa;\n      }\n\n      a {\n        color: #94a3b8;\n        text-decoration: none;\n        transition: color 0.2s;\n\n        &:hover { color: #60a5fa; }\n      }\n    }\n  }\n\n  .footer-bottom {\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    padding: 1.1rem 1.5rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    max-width: 1200px;\n    margin: 0 auto;\n    color: #64748b;\n    font-size: 0.82rem;\n\n    @media (max-width: 560px) {\n      flex-direction: column;\n      gap: 0.5rem;\n      text-align: center;\n    }\n\n    .footer-legal {\n      display: flex;\n      gap: 1.25rem;\n\n      a {\n        color: #64748b;\n        text-decoration: none;\n        transition: color 0.2s;\n\n        &:hover { color: #94a3b8; }\n      }\n    }\n  }\n\n  // Dark mode compatibility\n  @media (prefers-color-scheme: dark) {\n    background: #060e1c;\n  }\n}\n\n// Light-blue illustrated footer used by the public reference homepage.\n.site-footer {\n  position: relative;\n  overflow: hidden;\n  padding-top: 3.5rem;\n  background: #2f8ccc;\n  color: rgba(255,255,255,.86);\n\n  .footer-container { position: relative; z-index: 1; padding-bottom: 4.5rem; }\n  .footer-brand .footer-tagline, .footer-links a, .footer-contact li, .footer-contact li a { color: rgba(255,255,255,.72); }\n  .footer-links a:hover, .footer-contact li a:hover { color: #fff; }\n  .footer-contact li svg { color: #fff; }\n  .footer-brand .footer-social a { background: rgba(255,255,255,.14); color: #fff; }\n  .footer-bottom { position: relative; z-index: 1; color: rgba(255,255,255,.7); border-color: rgba(255,255,255,.18); }\n  .footer-bottom .footer-legal a { color: rgba(255,255,255,.7); &:hover { color: #fff; } }\n\n  &::after {\n    content: '';\n    position: absolute;\n    right: 0;\n    bottom: -35px;\n    left: 0;\n    height: 180px;\n    opacity: .13;\n    background: repeating-linear-gradient(90deg, transparent 0 45px, #fff 46px 48px, transparent 49px 82px);\n    clip-path: polygon(0 100%,0 75%,6% 75%,6% 55%,11% 55%,11% 82%,18% 82%,18% 42%,23% 42%,23% 70%,31% 70%,31% 52%,38% 52%,38% 78%,45% 78%,49% 0,53% 78%,60% 78%,60% 45%,66% 45%,66% 72%,73% 72%,73% 35%,78% 35%,78% 70%,85% 70%,85% 50%,91% 50%,91% 79%,100% 79%,100% 100%);\n  }\n}\n\n// Compact illustrated public footer matching the approved homepage reference.\n.site-footer {\n  position: relative;\n  min-height: 335px;\n  overflow: hidden;\n  padding: 38px 0 0;\n  background: #2f8ccc;\n  color: rgba(255, 255, 255, .82);\n  font-size: 12px;\n  &::after { display: none; }\n\n  .footer-container {\n    position: relative;\n    z-index: 2;\n    display: grid;\n    grid-template-columns: 1.1fr 1fr 1fr 1fr 1.3fr;\n    gap: clamp(28px, 5vw, 72px);\n    width: min(calc(100% - 48px), 1216px);\n    max-width: 1216px;\n    margin: 0 auto;\n    padding: 0;\n  }\n\n  .footer-brand__link {\n    display: inline-flex;\n    align-items: center;\n    gap: 9px;\n    color: #fff;\n    text-decoration: none;\n    transition: opacity .2s ease;\n    &:hover { opacity: .8; }\n    &:focus-visible { outline: 2px solid #fff; outline-offset: 5px; }\n    img { width: 34px; height: 34px; filter: brightness(0) invert(1); }\n    strong { font-size: 16px; font-weight: 700; letter-spacing: -.02em; white-space: nowrap; }\n  }\n\n  .footer-heading { margin: 0 0 14px; color: #fff; font-size: 13px; font-weight: 700; letter-spacing: 0; text-transform: none; }\n  .footer-links { display: flex; flex-direction: column; gap: 10px; margin: 0; padding: 0; list-style: none; }\n  .footer-links a { color: rgba(255,255,255,.72); text-decoration: none; transition: color .2s ease; }\n  .footer-links a:hover { color: #fff; }\n  .footer-links a:focus-visible { outline: 2px solid #fff; outline-offset: 3px; }\n\n  .footer-contact { display: block; margin: 0; padding: 0; }\n  .footer-contact p { margin: 0 0 10px; color: rgba(255,255,255,.72); line-height: 1.45; }\n  .footer-contact a { color: inherit; text-decoration: none; overflow-wrap: anywhere; }\n  .footer-contact a:hover { color: #fff; }\n\n  .footer-skyline { position: absolute; z-index: 1; right: 0; bottom: -3px; left: 0; width: 100%; height: 225px; object-fit: cover; object-position: center bottom; opacity: .34; filter: brightness(1.35); pointer-events: none; }\n\n  .footer-bottom {\n    position: absolute;\n    z-index: 2;\n    right: 0;\n    bottom: 12px;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 18px;\n    max-width: none;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    color: rgba(255,255,255,.75);\n    font-size: 10px;\n    p { margin: 0; }\n  }\n\n  .footer-social { position: relative; display: block; width: 102px; height: 18px; }\n  .footer-social img { display: block; width: 102px; height: 18px; object-fit: contain; }\n  .footer-social a { position: absolute; z-index: 1; top: -4px; bottom: -4px; display: block; }\n  .footer-social a:hover { background: rgba(255,255,255,.12); border-radius: 5px; }\n  .footer-social a:focus-visible { outline: 2px solid #fff; outline-offset: 2px; }\n  .footer-social__facebook { left: 0; width: 22%; }\n  .footer-social__instagram { left: 29%; width: 28%; }\n  .footer-social__youtube { right: 0; width: 28%; }\n\n  @media (max-width: 900px) {\n    min-height: 470px;\n    .footer-container { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 30px 50px; }\n    .footer-brand { grid-column: 1 / -1; }\n    .footer-skyline { height: 235px; }\n  }\n\n  @media (max-width: 560px) {\n    min-height: 690px;\n    padding-top: 32px;\n    .footer-container { grid-template-columns: 1fr; width: min(calc(100% - 40px), 420px); gap: 25px; }\n    .footer-brand { grid-column: auto; }\n    .footer-skyline { left: -30%; width: 160%; max-width: none; height: 210px; }\n    .footer-bottom { bottom: 14px; flex-direction: column; gap: 9px; }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
